module.exports = __webpack_public_path__ + "media/images/how_it_works/lend-f102e639384f756663a9da16e19175cb.svg";